import { HeaderLink } from '../../components';

export const ambassadorLinks: HeaderLink[] = [
  { href: '/ambassadors/join', label: 'BECOME AN AMBASSADOR' },
  { href: '/', label: 'WALDO FOR DOCTORS' },
  {
    href: 'https://www.hiwaldo.com/pages/experts',
    label: 'MEET OUR EXPERTS',
    newTab: true,
  },
];
